export function fmtCur(n, cur = "USD") {
  if (!Number.isFinite(n) || n <= 0) return "$0";
  const sym = { USD: "$", INR: "\u20B9", AED: "AED\u00A0", GBP: "\u00A3" }[cur] || "$";
  if (cur === "INR") {
    if (n >= 1e7) return `${sym}${(n / 1e7).toFixed(1)}Cr`;
    if (n >= 1e5) return `${sym}${(n / 1e5).toFixed(1)}L`;
    return `${sym}${n.toLocaleString()}`;
  }
  if (n >= 1e9) return `${sym}${(n / 1e9).toFixed(1)}B`;
  if (n >= 1e6) return `${sym}${(n / 1e6).toFixed(0)}M`;
  return `${sym}${n.toLocaleString()}`;
}
